import { styled, Container, Paper } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import Layout from 'layouts';

export const StyledLayout = styled(Layout)`
  padding-top: 0 !important;
`;

export const StyledContainer = styled(Container)`
  ${theme.breakpoints.up('sm')} {
    padding-top: 1rem;
  }
`;

export const StyledPaper = styled(Paper)`
  height: 100%;
  margin: auto;
  max-width: 550px;
  padding: 0;
  width: 100%;

  ${theme.breakpoints.up('sm')} {
    height: auto;
  }
`;
